export default "__VITE_ASSET__Ber28Kor__"